<div class="together">
  <ng-container *ngFor="let filterItem of filterItems">
    <cbre-filter
      [form]="form"
      [filter]="filterItem"
      [aggregations]="aggregations"
      [showLabel]="true"
      (filterOptionChange)="filterOptionChange.emit($event)"
    >
    </cbre-filter>
  </ng-container>
  <mat-icon *ngIf="canRemoveFilter" (click)="onRemoveFilter($event, filter)">close</mat-icon>
</div>
